import {
  AppointmentActivity,
  AppointmentApi,
  LogAppointmentActivityRequest,
} from "appointment-experience-client";
import { spire360ApiClient } from "./Spire360ApiClient";
import axios, { AxiosInstance } from "axios";
import { createCommonConfigurationForApis } from "./CommonHelper";

// Static service userid used by createCommonConfigurationForApis for non-gateway
// auth (the generated clients send it as the `userid` header).
const SERVICE_USER_ID = "afcb9359-d4d4-4ed7-9e1c-c5b326ff1b66";

// Fetch a fresh Zoom host start_url for a coach at join time. Not on the
// generated client yet (added as an authenticated GET on appointment-experience-api);
// this thin helper mirrors createAppointmentApi's gateway/non-gateway auth until
// the client is regenerated.
export async function getZoomHostStartUrl(
  appointmentId: string,
): Promise<string> {
  const path = `/appointment/zoom/host-start-url/${appointmentId}`;
  const isGatewayEnabled = process.env.REACT_APP_CONFIG_GATEWAY === "true";
  if (isGatewayEnabled) {
    const basePath = `${process.env.REACT_APP_APPOINTMENT_API_URL_GATEWAY}`;
    const res = await spire360ApiClient.get<string>(`${basePath}${path}`);
    return res.data;
  }
  const basePath = `${process.env.REACT_APP_APPOINTMENT_API_URL}`;
  const res = await axios.get<string>(`${basePath}${path}`, {
    headers: { userid: SERVICE_USER_ID },
  });
  return res.data;
}

export function createAppointmentApi(): AppointmentApi {
  const isGatewayEnabled = process.env.REACT_APP_CONFIG_GATEWAY === "true";
  if (isGatewayEnabled) {
    const basePath = `${process.env.REACT_APP_APPOINTMENT_API_URL_GATEWAY}`;
    const axiosInstance: AxiosInstance = spire360ApiClient;
    return new AppointmentApi(undefined, basePath, axiosInstance);
  } else {
    const basePath = `${process.env.REACT_APP_APPOINTMENT_API_URL}`;
    return new AppointmentApi(createCommonConfigurationForApis(), basePath);
  }
}

/** Everything logged against the appointment (WCP-13264), oldest first. */
export async function fetchAppointmentActivities(
  appointmentId: string
): Promise<AppointmentActivity[]> {
  const response =
    await createAppointmentApi().appointmentActivityControllerGetAppointmentActivities(
      appointmentId
    );
  return response.data;
}

/** Everything logged across all of the patient's appointments, oldest first. */
export async function fetchPatientAppointmentActivities(
  patientId: string
): Promise<AppointmentActivity[]> {
  const response =
    await createAppointmentApi().appointmentActivityControllerGetPatientAppointmentActivities(
      patientId
    );
  return response.data;
}

/** Records an action on an item worked during the appointment. */
export async function logAppointmentActivity(
  appointmentId: string,
  request: LogAppointmentActivityRequest
): Promise<AppointmentActivity> {
  const response =
    await createAppointmentApi().appointmentActivityControllerLogAppointmentActivity(
      request,
      appointmentId
    );
  return response.data;
}
